export const setLocalStorageTokens = (authData) => {
  localStorage.setItem("accessToken", authData.accessToken);
  localStorage.setItem("refreshToken", authData.refreshToken);
  if (authData.accessTokenExpiresAt) {
    localStorage.setItem(
      "accessTokenExpiresAt",
      String(authData.accessTokenExpiresAt),
    );
  }
};

export const removeLocalStorageTokens = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("accessTokenExpiresAt");
};

// Mirrors mobile's saveLoginHints/getLoginHints: remember the last phone login
// so returning users land on a prefilled login form.
export const saveLoginHints = (phoneNumber, country) => {
  if (phoneNumber) localStorage.setItem("lastLoginPhone", phoneNumber);
  if (country) localStorage.setItem("lastLoginCountry", country);
};

export const getLoginHints = () => ({
  phoneNumber: localStorage.getItem("lastLoginPhone") || null,
  country: localStorage.getItem("lastLoginCountry") || null,
});
